import { render, staticRenderFns } from "./ChatboxModalConfirmTextReply.vue?vue&type=template&id=038b0182&scoped=true&"
import script from "./ChatboxModalConfirmTextReply.vue?vue&type=script&lang=js&"
export * from "./ChatboxModalConfirmTextReply.vue?vue&type=script&lang=js&"
import style0 from "./ChatboxModalConfirmTextReply.vue?vue&type=style&index=0&id=038b0182&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b0182",
  null
  
)

export default component.exports